import React from "react";
import AllColors from "./ColorModule/AllColors";

const Colors = () => {
  return (
    <div>
      <AllColors />
    </div>
  );
};

export default Colors;
